import Image from 'next/image';

export const BrandSymbol: React.FC = () => {
	return (
		<Image alt="Fortnox Brand Symbol" loading="lazy" src="/brand/fortnox-brand-symbol.svg" width={51} height={51} />
	);
};
